import fonts from './fonts';

const mixins = {
  flexColCenter: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  flexRowCenter: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  HeadlineXL: {
    fontFamily: fonts.primary,
    fontOpticalSizing: 'auto',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '9.6rem',
    lineHeight: '100%',
    letterSpacing: '-0.02em',
  },
  HeadlineXLMobile: {
    fontFamily: fonts.primary,
    fontOpticalSizing: 'auto',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '5.4rem',
    lineHeight: '100%',
    letterSpacing: '-0.02em',
  },
  HeadlineL: {
    fontFamily: fonts.primary,
    fontOpticalSizing: 'auto',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '4.8rem',
    lineHeight: '100%',
    letterSpacing: '-0.02em',
  },
  Body: {
    fontFamily: fonts.primary,
    fontOpticalSizing: 'auto',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '1.5rem',
    lineHeight: '140%',
    letterSpacing: '-0.02em',
  },
  MonoXL: {
    fontFamily: fonts.secondary,
    fontOpticalSizing: 'auto',
    fontWeight: 300,
    fontStyle: 'normal',
    fontSize: '3.2rem',
    textTransform: 'uppercase',
  },
  MonoM: {
    fontFamily: fonts.secondary,
    fontOpticalSizing: 'auto',
    fontWeight: 300,
    fontStyle: 'normal',
    fontSize: '1.5rem',
    textTransform: 'uppercase',
  },
  Mono: {
    fontFamily: fonts.secondary,
    fontOpticalSizing: 'auto',
    fontWeight: 300,
    fontStyle: 'normal',
    fontSize: '1.2rem',
    textTransform: 'uppercase',
  },
};
export default mixins;
